import { useHttp } from "@/composables/useHttp"

export function useCitiesHttp() {
  const http = useHttp()

  async function cities(country: string) {
    const response = await http.get(`countries/${country}/cities`)

    return response.data.data.sort((a, b) =>
      a.attributes.slug > b.attributes.slug ? 1 : -1,
    )
  }

  async function city(country: string, city: string) {
    const response = await http.get(`countries/${country}/cities/${city}`)

    return response.data.data
  }

  return {
    city,
    cities,
  }
}
